import { c as _c } from "react/compiler-runtime";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
interface SelectInputProps {
  label: string;
  description?: string;
  headerRight?: React.ReactNode;
  value: string;
  options: string[];
  optionLabels?: string[];
  renderOption?: (option: string, label: string) => React.ReactNode;
  onChange: (value: string) => void;
  required?: boolean;
}
export default function SelectInput(t0) {
  const $ = _c(27);
  const {
    label,
    description,
    headerRight,
    value,
    options,
    optionLabels,
    renderOption,
    onChange,
    required
  } = t0;
  let t1;
  if ($[0] !== headerRight || $[1] !== label || $[2] !== required) {
    t1 = label && <div className="flex items-center justify-between gap-3"><label className="field-label block">{label}{required && <span className="ml-1 text-red-500">*</span>}</label>{headerRight}</div>;
    $[0] = headerRight;
    $[1] = label;
    $[2] = required;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== description) {
    t2 = description && <p className="text-ds-text-subtle dark:text-ds-text-disabled text-xs">{description}</p>;
    $[4] = description;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = value || "__empty__";
  let t4;
  if ($[6] !== onChange) {
    t4 = v => onChange(v === "__empty__" ? "" : v);
    $[6] = onChange;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SelectTrigger className="border-ds-neutral-300 text-ds-text-primary dark:border-ds-neutral-700 bg-ds-surface-card h-10 w-full rounded-lg border text-sm"><SelectValue placeholder="Select an option" /></SelectTrigger>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SelectItem value="__empty__">Select an option</SelectItem>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== optionLabels || $[11] !== options || $[12] !== renderOption) {
    let t8;
    if ($[14] !== optionLabels || $[15] !== renderOption) {
      t8 = (option, idx) => {
        const displayLabel = optionLabels?.[idx] || option;
        return <SelectItem key={option} value={option} textValue={displayLabel}>{renderOption ? renderOption(option, displayLabel) : displayLabel}</SelectItem>;
      };
      $[14] = optionLabels;
      $[15] = renderOption;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    t7 = options.map(t8);
    $[10] = optionLabels;
    $[11] = options;
    $[12] = renderOption;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[17] !== t7) {
    t8 = <SelectContent>{t6}{t7}</SelectContent>;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t3 || $[20] !== t4 || $[21] !== t8) {
    t9 = <Select value={t3} onValueChange={t4}>{t5}{t8}</Select>;
    $[19] = t3;
    $[20] = t4;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t1 || $[24] !== t2 || $[25] !== t9) {
    t10 = <div className="space-y-2">{t1}{t2}{t9}</div>;
    $[23] = t1;
    $[24] = t2;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
}